import React from "react";
import { Route } from "react-router-dom";
import config from "../config.json";

export const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      localStorage.getItem("user") ? (
        <Component {...props} />
      ) : (
        <>
          {(window.location.href = config.ACCOUNT_PORTAL_URL + "/login?m=rs")}
        </>
      )
    }
  />
);
